/**
 * The modules in this release (browser halves). `npm run new-module` adds a line here.
 * The app shell builds the menu and routes from these, filtered to the company's modules
 * and the user's permissions.
 */
import type { WebModule } from "@tc/ui";
import bonuses from "@tc/mod-bonuses/web";
import budgets from "@tc/mod-budgets/web";
import commissions from "@tc/mod-commissions/web";
import dashboard from "@tc/mod-dashboard/web";
import maintenance from "@tc/mod-maintenance/web";
import operators from "@tc/mod-operators/web";
import sites from "@tc/mod-sites/web";
import cashOffice from "@tc/mod-cash-office/web";
import tasks from "@tc/mod-tasks/web";
import audits from "@tc/mod-audits/web";
import reports from "@tc/mod-reports/web";
import fines from "@tc/mod-fines/web";
import rentReview from "@tc/mod-rent-review/web";
import fuel from "@tc/mod-fuel/web";
import hr from "@tc/mod-hr/web";
import learning from "@tc/mod-learning/web";
import wetstock from "@tc/mod-wetstock/web";
import compliance from "@tc/mod-compliance/web";
import products from "@tc/mod-products/web";
import prices from "@tc/mod-prices/web";
import promotions from "@tc/mod-promotions/web";
import wholesaler from "@tc/mod-wholesaler/web";
import suppliers from "@tc/mod-suppliers/web";
import carwash from "@tc/mod-carwash/web";
import signage from "@tc/mod-signage/web";
import chat from "@tc/mod-chat/web";
import insights from "@tc/mod-insights/web";
import loyalty from "@tc/mod-loyalty/web";
import productUpdates from "@tc/mod-product-updates/web";
import projects from "@tc/mod-projects/web";
import monitor from "@tc/mod-monitor/web";
export const webModules: WebModule[] = [dashboard, sites, maintenance, budgets, bonuses, operators, commissions, cashOffice, tasks, audits, reports, fines, rentReview, fuel, wetstock, hr, learning, compliance, products, prices, promotions, wholesaler, suppliers, carwash, signage, chat, insights, loyalty, productUpdates, projects, monitor];
